// Web addresses in a note's text, found to be drawn as links.

export interface Link {
  from: number;
  to: number;
  url: string;
}

const prefix = /^(?:https?:\/\/|www\.)/i;
const address = /\b(?:https?:\/\/|www\.)[^\s<>"'`]+/gi;

// punctuation that more likely ends the sentence than the address
const trailing = /[.,;:!?*_~]+$/;

const count = (s: string, c: string) => s.split(c).length - 1;

// trailing punctuation off, and a closing bracket the address didn't open,
// as in `(see https://example.com)`
const trim = (s: string): string => {
  const t = s.replace(trailing, '');
  const close = t.at(-1);
  const open = close === ')' ? '(' : close === ']' ? '[' : null;
  return open && count(t, close!) > count(t, open) ? trim(t.slice(0, -1)) : t;
};

export const findLinks = (text: string): Link[] =>
  [...text.matchAll(address)]
    .map(m => ({ from: m.index, text: trim(m[0]) }))
    // something left past the scheme once trimmed
    .filter(m => m.text.replace(prefix, ''))
    .map(({ from, text }) => ({
      from,
      to: from + text.length,
      url: /^www\./i.test(text) ? `https://${text}` : text,
    }));
